import { Navigate, useLocation } from "react-router-dom";

/**
 * מאפשר כניסה מ־/dashboard (ללא /p) — מפנה ל־/p/dashboard/* עם שמירת query/hash.
 * /dashboard ו־/dashboard/ → /p/dashboard/home
 */
export default function DashboardPublicRedirect() {
  const { pathname, search, hash } = useLocation();
  const normalized =
    pathname === "/dashboard" || pathname === "/dashboard/"
      ? "/p/dashboard/home"
      : pathname.replace(/^\/dashboard(\/?|$)/, "/p/dashboard$1");
  const target =
    normalized.endsWith("/p/dashboard") || normalized.endsWith("/p/dashboard/")
      ? "/p/dashboard/home"
      : normalized;
  return <Navigate to={`${target}${search}${hash}`} replace />;
}
